import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import AdDisplay from './AdDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AdInHouse(props) {
  var ad = props.ad;
  return /*#__PURE__*/_jsx(AdDisplay, {
    ad: _extends({
      poweredby: 'MUI',
      label: "in-house-".concat(ad.name)
    }, ad)
  });
}